export default {
	"관리자 권한": [
		{ "name": "로그인", "method": "post", "url": "/login", "permission": true },

		{ "name": "회원관리: 회원 조회", "method": "post", "url": "/member", "permission": true },
		{ "name": "회원관리: 회원 등록", "method": "put", "url": "/member", "permission": true },
		{ "name": "회원관리: 회원정보 수정", "method": "patch", "url": "/member", "permission": true },
		{ "name": "회원관리: 회원 탈퇴", "method": "delete", "url": "/member", "permission": true },

		{ "name": "수강관리: 수강정보 조회", "method": "post", "url": "/appl", "permission": true },
		{ "name": "수강관리: 수강정보 수정", "method": "patch", "url": "/appl", "permission": true },
		{ "name": "수강관리: 수강정보 삭제", "method": "delete", "url": "/appl", "permission": true },
		{ "name": "수강관리: 강좌 조회", "method": "post", "url": "/lec", "permission": true },
		{ "name": "수강관리: 강좌 등록", "method": "put", "url": "/lec", "permission": true },
		{ "name": "수강관리: 강좌 수정", "method": "patch", "url": "/lec", "permission": true },
		{ "name": "수강관리: 강좌 삭제", "method": "delete", "url": "/lec", "permission": true },

		{ "name": "게시판관리: 게시판 생성", "method": "put", "url": "/board", "permission": true },
		{ "name": "게시판관리: 게시판 수정", "method": "patch", "url": "/board", "permission": true },
		{ "name": "게시판관리: 게시판 삭제", "method": "delete", "url": "/board", "permission": true },
		{ "name": "게시판관리: 게시물 조회", "method": "post", "url": "/article", "permission": true },
		{ "name": "게시판관리: 게시물 등록", "method": "put", "url": "/article", "permission": true },
		{ "name": "게시판관리: 게시물 수정", "method": "patch", "url": "/article", "permission": true },
		{ "name": "게시판관리: 게시물 삭제", "method": "delete", "url": "/article", "permission": true },
		{ "name": "게시판관리: 댓글 등록", "method": "put", "url": "/comment", "permission": true },
		{ "name": "게시판관리: 댓글 수정", "method": "patch", "url": "/comment", "permission": true },
		{ "name": "게시판관리: 댓글 삭제", "method": "delete", "url": "/comment", "permission": true },

		{ "name": "상담관리: 상담 조회", "method": "post", "url": "/counsel", "permission": true },
		{ "name": "상담관리: 상담 등록", "method": "put", "url": "/counsel", "permission": true },
		{ "name": "상담관리: 상담 수정", "method": "patch", "url": "/counsel", "permission": true },
		{ "name": "상담관리: 상담 삭제", "method": "delete", "url": "/counsel", "permission": true },

		{ "name": "사이트관리: 사이트 조회", "method": "post", "url": "/site", "permission": true },
		{ "name": "사이트관리: 사이트 등록", "method": "put", "url": "/site", "permission": true },
		{ "name": "사이트관리: 사이트 수정", "method": "patch", "url": "/site", "permission": true },
		{ "name": "사이트관리: 사이트 삭제", "method": "delete", "url": "/site", "permission": true },

		{ "name": "교육관리: 강좌분류 등록", "method": "put", "url": "/sys/cate", "permission": true },
		{ "name": "교육관리: 강좌분류 수정", "method": "patch", "url": "/sys/cate", "permission": true },
		{ "name": "교육관리: 강좌분류 삭제", "method": "delete", "url": "/sys/cate", "permission": true },
		{ "name": "교육관리: 강좌개설 초기값 수정", "method": "patch", "url": "{?}", "permission": true },
		{ "name": "교육관리: 신청안내 수정", "method": "patch", "url": "/applGuide", "permission": true },

		{ "name": "전자우편 양식 등록", "method": "put", "url": "{?}", "permission": true },
		{ "name": "문자 양식 등록", "method": "put", "url": "{?}", "permission": true }
	],

	"CMS 권한": [
		{ "name": "로그인", "method": "post", "url": "/login", "permission": true },
		{ "name": "폴더 열람", "method": "get", "url": "/cms", "permission": true },
		{ "name": "폴더 생성/파일 업로드", "method": "post", "url": "/cms", "permission": true },
		{ "name": "파일조작 (HLS/압축해제/공유/복사/이동)", "method": "patch", "url": "/cms", "permission": true },
		{ "name": "폴더/파일 삭제", "method": "delete", "url": "/cms", "permission": true },
		{ "name": "휴지통에서 파일 복원", "method": "patch", "url": "/trash", "permission": true },
		{ "name": "휴지통에서 파일 삭제", "method": "delete", "url": "/trash", "permission": true }
	],

	"강사 권한": [
	],

	"관리자 메뉴": {
		"회원관리": {
			"enabled": true,
			"childs": {
				"수강생 관리": { "enabled": true },
				"강사 관리": { "enabled": true },
				"관리자 관리": { "enabled": true }
			}
		},
		"수강관리": {
			"enabled": true,
			"childs": {
				"수강 신청 관리": { "enabled": true },
				"수강현황 관리": { "enabled": true },
				"강좌 관리": { "enabled": true }
			}
		},
		"상담관리": {
			"enabled": true,
			"childs": {
				"상담글 목록": { "enabled": true },
				"상담 통계": { "enabled": true },
			}
		},
		"게시판관리": {
			"enabled": true,
			"childs": {
				"게시물 목록": { "enabled": true }
			}
		},
		"통계관리": {
			"enabled": true,
		},
		"사이트 관리": {
			"enabled": true,
			"childs": {
				"사이트 관리": { "enabled": true },
			}
		},
		"메뉴 관리": {
			"enabled": true
		},
		"교육 관리": {
			"enabled": true,
			"childs": {
				"강좌 분류": { "enabled": true },
				"강좌개설 초기값": { "enabled": true },
				"신청안내 설정": { "enabled": true }
			}
		},
		"전자우편 관리": {
			"enabled": true,
			"childs": {
				"전자우편 양식 관리": { "enabled": true },
				"보낸 우편함": { "enabled": true }
			}
		},
		"문자 관리": {
			"enabled": true,
			"childs": {
				"문자 양식 관리": { "enabled": true },
				"보낸 문자함": { "enabled": true }
			}
		},
		"설문 관리": {
			"enabled": true,
			"childs": {
				"설문 관리": { "enabled": true },
				"설문문항 관리": { "enabled": true },
				"과정별 설문 초기값": { "enabled": true },
				"설문 분류": { "enabled": true },
				"설문 통계": { "enabled": true }
			}
		},
		"시험 관리": {
			"enabled": true,
			"childs": {
				"시험문항 관리": { "enabled": true },
				"과정별 설문 초기값": { "enabled": true },
				"시험 분류": { "enabled": true },
				"시험 통계": { "enabled": true }
			}
		},
		"강의지원": {
			"enabled": true,
			"childs": {
				"소속기관 관리": { "enabled": true }
			}
		},
		"팝업 관리": {
			"enabled": true,
			"childs": {
				"누리집 팝업 관리": { "enabled": true }
			}
		}
	},
}